<template>
  <div>
    <el-form
      ref="ruleForm"
      label-position="left"
      :model="ruleForm"
      :rules="rules"
      label-width="100px"
      class="demo-ruleForm"
    >
      <div style="display:flex;">
        <el-form-item
          label="间隔弹广告(n到n+1)"
          prop="septal"
          label-width="190px"
        >
          <el-input
            v-model="ruleForm.septal"
            v-numberOnly
            max="9999"
            placeholder="请输入"
          />
        </el-form-item>
        <el-form-item
          label-width="200px"
          label="推荐视频是否全部开启广告"
          prop="recommend_all_ad"
        >
          <el-switch
            v-model="ruleForm.recommend_all_ad"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="ruleForm.recommend_all_ad == 1 ? '关闭' : ''"
            :inactive-text="ruleForm.recommend_all_ad == 2 ? '开启' : ''"
            @change="changewr"
          />
        </el-form-item>
      </div>
      <div>
        <el-form-item
          label-width="200px"
          label="文章是否展示开关"
          prop="open_article"
        >
          <el-switch
            v-model="ruleForm.open_article"
            :inactive-value="1"
            :active-value="2"
            active-color="#13ce66"
            inactive-color="rgb(191,191,191)"
            :active-text="ruleForm.open_article == 1 ? '关闭' : ''"
            :inactive-text="ruleForm.open_article == 2 ? '开启' : ''"
          />
        </el-form-item>
      </div>
      <el-form-item
        label-width="200px"
        label="自动播放广告"
        prop="encourage_ad_automatic"
      >
        <el-switch
          v-model="ruleForm.encourage_ad_automatic"
          :inactive-value="2"
          :active-value="1"
          active-color="#13ce66"
          inactive-color="rgb(191,191,191)"
          :active-text="ruleForm.encourage_ad_automatic == 1 ? '开启' : ''"
          :inactive-text="ruleForm.encourage_ad_automatic == 2 ? '关闭' : ''"
        />
      </el-form-item>
      <div
        v-if="type"
        style="display:flex;"
      >
        <el-form-item
          label="选择小程序"
          prop="app_ids"
        >
          <!-- <el-button size="mini" type="primary">选择</el-button> -->
          <el-button
            style="margin-right:10px"
            type="primary"
            size="mini"
            @click="chooseidsr"
          >选择小程序</el-button>
          <span>
            <el-tag
              v-for="item,index in ruleForm.app_ids"
              :key="index"
              closable
              style="margin-right:10px"
              @close="handleClose(item,index)"
            >{{ item.account_name }}</el-tag>
          </span>
        </el-form-item>
      </div>
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <!-- 加载进度条的样式 -->
    <div
      v-if="showProgress"
      class="bacc"
    >
      <div class="jindutiao">
        <el-progress
          type="circle"
          :percentage="percentage"
          :width="80"
          class="progressCircle"
        />
      </div>
    </div>
    <el-dialog
      title="选择小程序"
      :visible.sync="dialogVisibler"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :append-to-body="true"
      width="60%"
    >
      <bandstaff
        ref="bandstaffview"
        @bandarr="bandarr"
      />
    </el-dialog>
  </div>
</template>
<script>
import bandstaff from './bandstaff.vue'
export default {
  components: {
    bandstaff
  },
  directives: {
    numberOnly: {
      bind(el) {
        el.addEventListener('input', function (event) {
          const input = event.target
          let value = input.value
          value = value.replace(/\D/g, '') // 只保留数字

          if (value.length > 4) {
            value = value.slice(0, 4) // 截取前4位数字
          }

          input.value = value
        })
      }
    }
  },
  data() {
    return {
      time: '',
      showProgress: false,
      percentage: 0,
      ruleForm: {
        app_ids: [],
        septal: null,
        encourage_ad_automatic: 1,
        recommend_all_ad: 2,
        open_article: 2
      },
      rules: {
        septal: [{ required: true, message: '请输入', trigger: 'blur' }]
      },
      loading: false,
      tableData: {
        list: [],
        total: 10
      },
      dialogVisible: false,
      dialogVisibler: false,
      type: false
    }
  },
  created() {
    this.reset()
  },
  // 页面初始化挂载dom
  mounted() {},
  methods: {
    async bandarr(arrs) {
      this.ruleForm.app_ids = arrs
      this.dialogVisibler = false
    },
    handleClose(item, index) {
      this.ruleForm.app_ids.splice(index, 1)
    },
    chooseidsr() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        console.log('this.ruleForm.id:', this.ruleForm.id)
        this.$refs.bandstaffview.sendr(this.ruleForm.app_ids, this.ruleForm.id)
      })
    },
    sendr(row) {
      console.log('row:', row)
      if (row === undefined) {
        this.ruleForm = {
          app_ids: [],
          septal: null,
          encourage_ad_automatic: 1,
          recommend_all_ad: 2,
          open_article: 2
        }
        this.type = true
        return
      }
      const item = JSON.parse(JSON.stringify(row))
      this.ruleForm = item
      console.log('this.ruleForm:', this.ruleForm)
    },
    submitForm(formName) {
      console.log(11, this.ruleForm)

      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log('this.type:', this.type)
          if (this.type) {
            console.log('this.ruleForm.app_ids:', this.ruleForm.app_ids)
            if (this.ruleForm.app_ids.length === 0) return this.$message('请选择小程序')
            this.ruleForm.app_ids = this.ruleForm.app_ids.map(v => v.app_id)
          }
          if (this.ruleForm.id) {
            const { id, septal, encourage_ad_automatic, recommend_all_ad, open_article } = this.ruleForm

            this.ruleForm = {
              id,
              septal,
              encourage_ad_automatic,
              recommend_all_ad,
              open_article
            }
          }

          console.log(11, this.ruleForm)
          this.$emit('determine', this.ruleForm)
          // this.reset()
          if (this.$refs.form !== undefined) {
            this.$refs.form.resetFields()
          }
        }
      })
    },

    async changewr(val) {
      console.log('val:', val)
      this.ruleForm.ad_configuration = val
    },
    // 重置
    reset() {
      this.ruleForm = {
        app_ids: [],
        septal: null,
        encourage_ad_automatic: 1,
        recommend_all_ad: 2,
        open_article: 2
      }
    }
  }
}
</script>
<style scoped>
.el-form-item {
  margin-bottom: 22px;
  margin: 10px;
}
.choose_palte {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.chasew {
  width: 80px;
  text-align: right;
}
.updatabocwr {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 130px;
  height: 130px;
  cursor: pointer;
  line-height: 146px;
  vertical-align: top;
  text-align: center;
}
.updatabocwr i {
  font-size: 28px;
  color: #8c939d;
}
.updatabocwr i:hover {
  border: none;
}
.wrwaw :hover {
  border: 1px dashed #409eff;
}
.updata_casr {
  width: 130px;
  height: 130px;
}
.bacc {
  /*bacc是灰色的大背景*/
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);
  /*这个类的作用是把进度条放到水平垂直居中的位置*/
}
.jindutiao {
  position: absolute;
  width: 150px;
  height: 150px;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  margin-top: -75px;
  display: flex;
  justify-content: center;
  align-items: center;
}
::v-deep .el-switch__label--right,
::v-deep .el-switch__label--left {
  background-color: #fff !important;
}
</style>
